<div class="root-container">

    <div class="title-container m-t-20 p-l-1vw p-t-1vw p-r-1vw">
        <mat-grid-list cols="2" rowHeight="50px">
            <mat-grid-tile flex-start flex-align-top class="grid-spacing">
                <h1 class="page-title">
                    {{('deadlineOrderAndSubscription') | translate}}
                </h1>
            </mat-grid-tile>
            <mat-grid-tile flex-end flex-align-top class="grid-spacing">

            </mat-grid-tile>
        </mat-grid-list>
    </div>


    <div class="main-container">

        <!-- Deadline order section  -->
        <mat-card class="m-t-20 m-b-0 m-l-20 m-r-20 p-t-10 p-b-10">
            <mat-card-header class="title">
                {{('deadlineOrder') | translate}}
            </mat-card-header>
            <mat-card-content class="m-t-10">
                <div class="d-flex flex-row" style="line-height: 30px;">
                    {{('deadlineOrderDescription') | translate}}
                </div>

                <div class="d-flex flex-row">

                    <div class="d-flex flex-col m-t-20">
                        <div>
                            <mat-form-field class="m-b-0" appearance="outline">
                                <mat-label>{{'deadline' | translate}}</mat-label>
                                <mat-select [(ngModel)]="selectedDeadline"
                                    (ngModelChange)="onDeadlineSelectionChanged($event)"
                                    [disabled]="deadlines.length == 0">
                                    <mat-option *ngFor="let deadline of deadlines" [value]="deadline">{{deadline |
                                        date}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="d-flex flex-col m-t-10 m-l-20">
                        <div class="bordered-container">
                            <mat-card-header class="title">
                                {{('apiImportParams') | translate}}
                            </mat-card-header>
                            <div *ngFor="let param of apiImportParams">
                                <div class="m-t-20">
                                    <p class="fw-500">{{param.paramTypeTranslationKey | translate}}</p>
                                </div>
                                <div>
                                    <table class="api-import-param-table">
                                        <tr>
                                            <td class="w-160" *ngFor="let paramOption of param.paramOptions">
                                                <mat-field appearance="outline" class="form-field ">
                                                    <mat-checkbox [checked]="paramOption.selected"
                                                        (change)="apiImportParamOptionCheckedChanged(paramOption)">
                                                        {{ paramOption.optionTranslationKey | translate }}
                                                    </mat-checkbox>
                                                </mat-field>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-col m-l-20 m-t-20">
                        <div>
                            <button mat-raised-button class="custom-button grey-text" style="margin-top: 4px;"
                                [disabled]="!selectedDeadline" (click)="orderDeadline()">{{'orderDeadline' |
                                translate}}</button>
                        </div>

                    </div>

                </div>
            </mat-card-content>
        </mat-card>

        <!-- Deadline subscription section -->
        <mat-card class="m-t-20 m-b-30 m-l-20 m-r-20 p-t-15 p-b-10">
            <mat-card-header class="title">
                {{('subscriptionMode') | translate}}
            </mat-card-header>
            <mat-card-content class="m-t-10">
                <div class="d-flex flex-row" style="line-height: 30px;">
                    {{('subscriptionModeDescription') | translate}}
                </div>

                <div class="m-t-20 bordered-container">

                    <div class="d-flex flex-row">
                    <mat-slide-toggle color="primary" [(ngModel)]="isSubscriptionEnabled"
                        (ngModelChange)="toggleSubscription($event)">
                        {{ (isSubscriptionEnabled ? 'active' : 'deactivated') | translate }}
                    </mat-slide-toggle>
                </div>

                <div *ngIf="isSubscriptionEnabled" class="d-flex flex-row m-t-10">
                    {{ 'apiImportSubscriptionNextDeadline' | translate }} {{nextSubscriptionDeadline |
                    date}}
                </div>
                </div>
                

                <div class=" d-flex flex-row m-t-20">
                    <button mat-raised-button class="custom-button upload-btn grey-text float-right"
                        (click)="navigateToImportParams()">{{'configureApiImportParams' |
                        translate}}</button>
                </div>

            </mat-card-content>
        </mat-card>

    </div>

    <div class="div-container" *ngIf="spinnerFlag">
        <div class="div-spinner">
            <mat-spinner class="custom-field" mode="indeterminate"></mat-spinner>
        </div>
    </div>


</div>